/**
 * Global
 * ------
 */
function handleScrollAnimation(){
  if ($w.scrollTop() > 200) {
    $b.addClass('is-scrolled');
  } else {
    $b.removeClass('is-scrolled');
  }
};


function openModal($target){
  $target.addClass('is-shown');
  $target.find('.modal-close').focus();
  $target.trigger('modal:shown');
}
function closeModal(){
  $b.removeClass('modal-open');
  $('.modal').removeClass('is-shown');
  let $embed = $('.modal.has-video').find('iframe');
  if ($embed.length) {
    let src = $embed.attr('src').replace('&autoplay=1','');
    $embed.attr('src', src); 
  }
}

function closeNavigationDropdowns(){
  $('.has-children').removeClass('is-open');
  $b.removeClass('dropdown-open');
}

$b.on('keyup', function(e){
  // keyCode is getting deprecated use key instead when supported, which makes this messy
  evt = e || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key == "Escape" || evt.key == "Esc");
  } else {
    isEscape = (evt.keyCode == 27);
  }
  if (isEscape) {
    closeModal();
    closeNavigationDropdowns();
    $b.removeClass('search-open');
    $('.album-lightbox').removeClass('shown');
  }
});

// shift navbar
window.addEventListener("scroll", () => {
  window.helpers.throttle(handleScrollAnimation, 250);
});

// announcement slider (sometimes)
if ($('#announcement-bar .item').length > 1) {
  $('#announcement-bar .items').slick({
    infinite: true,
    arrows: true,
    dots: false,
    prevArrow: `<button type="button" class="slick-prev"><span class="visually-hidden">Previous</span>${window.iconStrings.previousControl}</button>`,
    nextArrow: `<button type="button" class="slick-next"><span class="visually-hidden">Previous</span>${window.iconStrings.nextControl}</button>`
  });
}

// modals
$b.on('click', '.modal-trigger', function(e){
    e.preventDefault();
    let $target = $($(this).attr('href'));
    openModal($target);
});
$b.on('click', '.modal-close, .modal-dismiss', function(e){
  e.preventDefault();
  closeModal();
});
$('.modal.has-video').on('modal:shown', function(){
  let $embed = $(this).find('iframe');
  if ($embed.length) {
    let src = $embed.attr('src');
    $embed.attr('src', src + '&autoplay=1');
  }
});

// do this on load to wait for the element to be injected
$w.on('load', function(){
  if( window.location.hash === '#shop' ){
    openModal($('#hf-shop-modal'));
  }
});

// main nav
$('#site-navigation-open').on('click', function(e){
  e.preventDefault();
  e.stopPropagation();
  $b.addClass('site-navigation-open');
});
$('#site-navigation-close').on('click', function(e){
  e.preventDefault();
  $b.removeClass('site-navigation-open');
});
$('.level-1-link.has-children').on('click', function(e){
  e.preventDefault();
  e.stopPropagation();
  if ($(this).hasClass('is-open') ){
    closeNavigationDropdowns(); // close this menu
  } else {
    closeNavigationDropdowns(); // close other menus
    $(this).addClass('is-open'); // open this one
    $b.addClass('dropdown-open');
  }
});
$('.back-bar').on('click', function(e){
  e.preventDefault();
  closeNavigationDropdowns();
});
$b.on('click', function(){
  closeNavigationDropdowns();
});

// site search
$('#search-open').on('click', function(e){
  e.preventDefault();
  if( $b.hasClass('template-search') ){
    $('#ais-search .ais-SearchBox-input').select();
  } else {
    $b.addClass('search-open');
    $('#aac .aa-Input').select();
  }
});
$('#search-close').on('click', function(e){
  e.preventDefault();
  $b.removeClass('search-open');
});

// expanding panels
$b.on('click', '.expandable-panel .toggle', function(e){
  e.preventDefault();
  let $parent = $(this).closest('.expandable-panel');
  $parent.toggleClass('is-expanded');
  if ($parent.hasClass('is-expanded')) {
    $parent.find('.video').fitVids();
  } else {
    $parent.find('iframe').each(function(){
      let src = $(this).attr('src');
      $(this).attr('src',src); // kill playing videos
    })
  }
});

// footer expanding navs
$('.nav-toggle').on('click', function(e){
  e.preventDefault();
  let $target = $(this).closest('nav');
  $(this).toggleClass('is-expanded');
  if ($(this).hasClass('is-expanded')) {
   $target.addClass('shown');
  } else {
   $target.removeClass('shown');
  }
});

// floating field labels
$b.on('change', 'select', function(){
  if ($(this).val()) {
    $(this).closest('.field').addClass('has-value');
  } else {
    $(this).closest('.field').removeClass('has-value');
  }
});
$b.on('keyup', 'input', function(){
  if ($(this).val()) {
    $(this).closest('.field').addClass('has-value');
  } else {
    $(this).closest('.field').removeClass('has-value');
  }
});

const setBgVideoSrc = window.helpers.debounce(function(){
  $('.image-banner-video').each(function(){
    console.log(window.vars.breakpoints.lg);
    if ($w.width() < window.vars.breakpoints.lg) {
      $(this).html('');
    }else{
      if (!$(this).find('source').length) {
        $(this).append('<source src="' + $(this).data('src') + '" type="video/mp4"></source>');
      }
    }
  });
}, 250);
setBgVideoSrc();
window.addEventListener("resize", setBgVideoSrc);